import axios from 'axios';
import funcMoudle from './actionFunc/index';
import cyptos from './utils/cyptoSha1';
class FileService {
  constructor(token) {
    this.steps = [];
    this.action = [];
    this.fileInfo = null;
    this.uploadFuc = null;
    this.token =
      token ||
      (sessionStorage.getItem('user_info')
        ? JSON.parse(sessionStorage.getItem('user_info')).token
        : '');
  }

  initAction() {
    this.action = this.steps.reduce(
      (source, { action }) => [
        ...source,
        ...(Array.isArray(action)
          ? action
          : Object.getPrototypeOf(action) === Object.prototype
          ? Object.values(action)
          : []),
      ],
      []
    );
  }

  async startUploadMultipleFile(fileList = []) {
    let successFile = [];
    let errorFile = [];
    for (let index = 0; index < fileList.length; index++) {
      const file = fileList[index];
      const res = await this.startUploadSingleFile(file);
      if (res.success) {
        successFile.push(this.getFileInfo());
      } else {
        errorFile.push(file.name);
      }
    }
    this.fileInfo = null;
    return {
      success: errorFile.length === 0,
      data: {
        successFile,
        errorFile,
      },
      message:
        errorFile.length === 0 ? '上传成功' : `上传${errorFile.join(',')}失败`,
    };
  }

  async startUploadSingleFile(file) {
    const { type, message } = await this.initSteps(file);
    if (type === 'error') {
      return {
        success: false,
        message,
      };
    }
    if (type === 'success') {
      return {
        success: true,
      };
    }

    return await this.startUpload(file);
  }

  async initSteps(file) {
    try {
      const res = await this.handelHasFile(file);
      if (res.type === 'error') {
        return res;
      }
      if (res.type === 'success') {
        this.fileInfo = res.data || {};
      } else {
        const { provider } = res.data;
        if (!Object.prototype.hasOwnProperty.call(funcMoudle, provider)) {
          throw new Error(`没有${provider}.js文件`);
        }
        const Moudle = funcMoudle[provider];
        this.uploadFuc = new Moudle();
        this.steps = res.data.steps || [];
        this.initAction();
      }
      return res;
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  async startUpload(file) {
    this.fileInfo = {};
    if (this.uploadFuc.reset) {
      this.uploadFuc.reset();
    }
    try {
      let num = 0;
      for (let i = 0; i < this.action.length; i++) {
        const item = this.action[i];
        const { success } = await this.creatAxios(item, file);
        if (success) {
          num++;
        } else {
          break;
        }
      }
      if (num === this.action.length) {
        return {
          success: true,
        };
      } else {
        return {
          success: false,
          message: '上传失败',
        };
      }
    } catch (error) {
      console.error(error);
      throw new Error(error);
    }
  }

  getFileInfo() {
    return this.fileInfo || {};
  }

  async handelFiletoSha1(file) {
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    return new Promise(function (resolve, reject) {
      fileReader.onload = function (e) {
        resolve(cyptos(new Uint8Array(e.target.result)));
      };

      fileReader.onerror = reject;
    });
  }

  async handelHasFile(file) {
    const message = {
      type: 'success',
      message: '',
      data: null,
    };
    const sha1 = await this.handelFiletoSha1(file);
    const { name, type, size } = file;
    const data = {
      hash: `${sha1}`,
      extension: name.substring(name.lastIndexOf('.') + 1),
      filename: name,
      mimeType: type,
      ruleID: '1',
      size,
    };
    const response = await axios({
      method: 'POST',
      headers: {
        token: this.token,
      },
      data,
      url: '/api/buildedcache/getUploadStrategy',
    });


    const resultData = JSON.parse(response.data.data)

    if (Number(response.data.code) === 200) {
      if (data.fileInfo) {
        message.type = 'success';
        message.data = resultData.fileInfo;
      } else {
        message.type = 'upload';
        message.data = resultData
      }
    } else {
      message.type = 'error';
      message.message = response.data.message;
    }
    return message;
  }

  async sendRequest(func = '', parms = {}) {
    try {
      if (!this.uploadFuc[func]) {
        return;
      }
      const res = await this.uploadFuc[func](parms);
      return res;
    } catch (error) {
      console.error(error);
    }
  }

  async creatAxios(item = {}, file) {
    const { url, method } = item;
    let returnValue = {
      success: false,
    };
    let data = {
      isSendRequst: !item['before-request'],
      axiosConfig: {
        url,
        method,
      },
    };
    if (item['before-request']) {
      const res = await this.sendRequest(item['before-request'], {
        item,
        file,
      });
      if (res) {
        data = res;
      }
    }
    if (data.isSendRequst) {
      try {
        const res = await axios(data.axiosConfig);
        if (res.status === 200) {
          let afterData = null;
          if (item['after-request']) {
            afterData = await this.sendRequest(item['after-request'], {
              response: res,
              item,
              file,
            });
          }
          returnValue.success = true;
          if (afterData) {
            this.fileInfo = afterData.fileInfo || null;
            returnValue.success = afterData.success;
          }
        }
      } catch (error) {
        console.error(error);
        throw new Error(error);
      }
    } else {
      if (data.isNextSetp) {
        returnValue.success = true;
      }
    }

    return returnValue;
  }
}

export default FileService;
